import { z } from 'zod/v4-mini'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'

export const searchParamsDeletedItemSelectionSchema = z.object({
    deletedItemSelection: z._default(
        z.enum(DeletedItemSelection),
        DeletedItemSelection.NORMAL_ONLY
    ),
})

export const searchParamsDeletedItemSelectionDefaultValues: z.infer<
    typeof searchParamsDeletedItemSelectionSchema
> = {
    deletedItemSelection:
        searchParamsDeletedItemSelectionSchema.shape.deletedItemSelection.def
            .defaultValue,
}
